<template>
  <div class="category-cont">
    <div v-for="(category) in categories" ref="linksRef" class="category-item" :key="category.id"
      :class="{ active: category === value }">
      <div @click="onClickCategory(category)" :style="{
        backgroundImage: `var(--gradient), url(${category.thumbnail && category.thumbnail.url
          })`,
      }" class="category">
        <p class="title">
          {{ category.title }}
        </p>
        <p v-if="!category.visible" class="unavailable">
          {{ 'عدم نمایش' }}
        </p>
      </div>
      <div class="buttons">
        <vs-button @click="$emit('edit', category)" class="mr-1" color="primary" type="filled" size="small"
          icon-pack="feather" icon="icon-edit" />
        <vs-button @click="$emit('remove', category)" class="ml-1" color="danger" type="filled" size="small"
          icon-pack="feather" icon="icon-trash" />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Category",
  data() {
    return {};
  },
  mounted() {
    this.scrollIntoActiveCategory();
  },
  watch: {
    value(activeCategory) {
      const activeIndex = this.categories.findIndex(element => element.id === activeCategory.id);
      this.scrollIntoActiveCategory(activeIndex);
    }
  },
  methods: {
    onClickCategory(item) {
      window.scrollTo({ top: 0, behavior: 'auto' });
      this.$emit('input', item);
    },
    scrollIntoActiveCategory(index = 0) {
      if (this.$refs && this.$refs.linksRef && this.$refs.linksRef[index]) {
        try {
          this.$refs.linksRef[index].scrollIntoView({
            behavior: "auto",
            block: "center",
            inline: "center",
          });
        } catch (e) {
          console.log(e);
        }
      }
    },
  },
  props: {
    categories: {
      type: Array,
      required: true,
    },
    value: {
      type: Object,
    },
  },
};
</script>

<style scoped lang="scss">
.category-cont {
  display: flex;
  flex-direction: row;
  overflow: auto hidden;
  padding: 10px 0;
  margin-bottom: 20px;

  ul {
    list-style-type: none;
  }
}


.category-item {
  display: flex;
  flex-direction: column;

  .category {
    min-width: 100px;
    max-width: 200px;
    white-space: nowrap;
    cursor: pointer;
    border-radius: 5px;
    background-color: #e0e0e0;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding: 0 16px;
    height: 70px;
    position: relative;
    margin: 0 1px;
    transition: 0.3s all;
    background-size: cover;
    background-position: center;
    --gradient: linear-gradient(rgba(0, 0, 0, 0.7), rgba(0, 0, 0, 0.8));
    overflow: hidden;

    .title {
      font-weight: 400;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      color: #fff;
      text-align: center;
      font-size: 13px;
      max-width: 180px;
    }

    .unavailable {
      color: lightgrey;
      font-size: 0.8rem;
    }
  }

  .buttons {
    display: flex;
    margin: 5px 0 0;
    align-items: center;
    justify-content: center;
  }

  &.active .category {
    filter: drop-shadow(0 0 6px rgba(0, 0, 0, 0.5));
    font-weight: 500;
    --gradient: linear-gradient(to bottom right,
        rgba(15, 67, 123, 0.6),
        #03132c);
  }
}
</style>
